
export enum DescriptionColorEnum {
    'red' = 'red',
    'green' = 'green',
    'blue' = 'blue',
    "replenish" = 'replenish'  //补单颜色
}

export interface IDescription {
    label: string | JSX.Element;
    value: number | string | JSX.Element | JSX.Element[];
    color: DescriptionColorEnum;
    status?: boolean
    hidden?: boolean
}


export interface IYhBox {
    title?: string | JSX.Element | JSX.Element[];
    descriptions?: IDescription[];
    action?: JSX.Element;
    searchBox?: JSX.Element;
    width?: string;
    height?: string;
    maxWidth?: string;
    maxHeight?: string;
    style?: React.CSSProperties;
    rightChildren?: JSX.Element;
    contentClass?: string;
    hidden?: boolean
    rightTitle?: string | JSX.Element | JSX.Element[];
}